import * as moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { ApplicationState } from 'src/store';
import { getAllEventGroups } from 'src/store/eventgroups/actions';
import { CardEventGroup } from 'src/store/events/types';

import './ClosureManagementView.scss';
import { WeekDays, DateShortForms } from 'src/utils/dateHelper';
import { history } from 'src';
import { IconPaths } from 'src/icons';
import { confirmAlert } from 'react-confirm-alert';
import { deleteEvents } from 'src/store/events/actions';

interface Props {
  eventgroups: CardEventGroup[];
  loading: boolean;
  getAllEventGroups: () => any;
  deleteEvents: (cardGroupId: number, successCB: () => any) => any;
}

class ClosureManagementView extends React.Component<Props> {
  componentDidMount() {
    this.props.getAllEventGroups();
  }

  renderWeekdays = (weekdays?: any[]) => {
    const ret = [];
    for (const w in WeekDays) {
      if (!isNaN(Number(w)) && weekdays !== undefined) {
        ret.push(
          <li key={w} className={weekdays.indexOf(w) !== -1 ? 'active' : ''}>
            <span>{DateShortForms[WeekDays[w]]}</span>
          </li>
        );
      }
    }
    return ret;
  };

  editEvent = (id: number) => {
    history.push(`/section/undefined/${id}/edit`);
  };

  deleteEvent = (cardGroupId: number) => {
    confirmAlert({
      title: 'Veranstaltungen löschen',
      message: 'Wollen Sie wirklich alle Veranstaltungen dieses Typs löschen?',
      buttons: [
        {
          label: 'Löschen',
          onClick: () =>
            this.props.deleteEvents(cardGroupId, () => {
              this.props.getAllEventGroups();
            })
        },
        {
          label: 'Abbrechen',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  public render() {
    const eventgroups = this.props.eventgroups;
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <LoadingSpinner pending={this.props.loading} />
            <h1>Eventgruppen</h1>
            <table className="closureManage_table">
              <tbody>
                {eventgroups &&
                  eventgroups.map((e, i) => {
                    return (
                      <tr className="closureManage_item" key={i}>
                        <td>{i + 1}</td>
                        <td className="closureManage_title">
                          {e.events && e.events.length > 0 && e.events[0].title}
                        </td>
                        {e.dateranges && e.dateranges.length > 0 && (
                          <td className="closureManage_weekday">
                            <ul className="closureManage_weekday_ul">
                              {this.renderWeekdays(e.dateranges[0].weekdays)}
                            </ul>
                          </td>
                        )}

                        <td>
                          {e.dateranges &&
                            e.dateranges.map((d, index) => {
                              return (
                                <div key={index}>
                                  {d.start && moment(d.start).format('DD.MM.YYYY')} -
                                  {d.end && moment(d.end).format('DD.MM.YYYY')}
                                </div>
                              );
                            })}
                        </td>
                        <td>
                          <img
                            onClick={() => {
                              this.editEvent(e.events[0].id);
                            }}
                            src={IconPaths['edit-icon']}
                            title="Bearbeiten"
                            height="20px"
                            className="pointer"
                            style={{ marginRight: '10px' }}
                          />
                          <img
                            onClick={this.deleteEvent.bind(this, e.id)}
                            src={IconPaths['bin-icon']}
                            height="20px"
                            className="pointer"
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ eventgroup }: ApplicationState) => ({
  loading: eventgroup.loading,
  eventgroups: eventgroup.data
});

const mapDispatchToProps = (dispatch: any) => ({
  getAllEventGroups: () => dispatch(getAllEventGroups()),
  deleteEvents: (cardGroupId: number, successCB: () => any) =>
    dispatch(deleteEvents(cardGroupId, true, successCB))
});

export default connect(mapStateToProps, mapDispatchToProps)(ClosureManagementView);



// WEBPACK FOOTER //
// ./src/pages/Management/Closure/ClosureManagementView.tsx